import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { clientCaseService } from '../apps/clients/services'

// The old client_cases app lived at /client_cases/* with a case-first route
// shape (list/new/:slug[/edit]/:slug/reviews[...]). PR4 replaced it with the
// client-first /clients app (cases moved under /clients/cases/*, reviews
// re-parented to the client level). This view is registered globally
// (spa/src/routesConfig.js) at /client_cases/* and rewrites every old URL
// pattern to its new equivalent — most are static path rewrites, but the
// review sub-paths need an async hop: the old :slug was a CASE slug, and the
// new review routes live under the CLIENT's slug, so the case is fetched
// first to resolve it.
export const LegacyClientCasesRedirect = () => {
  const params = useParams()
  const navigate = useNavigate()
  const rest = params['*'] || ''
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    const segments = rest.split('/').filter(Boolean)

    // /client_cases -> /clients
    if (segments.length === 0) {
      navigate('/clients', { replace: true })
      return
    }

    // /client_cases/list -> /clients/cases
    if (segments[0] === 'list' && segments.length === 1) {
      navigate('/clients/cases', { replace: true })
      return
    }

    // /client_cases/new -> /clients/cases/new
    if (segments[0] === 'new' && segments.length === 1) {
      navigate('/clients/cases/new', { replace: true })
      return
    }

    const caseSlug = segments[0]

    // /client_cases/:slug -> /clients/cases/:slug
    // /client_cases/:slug/edit -> /clients/cases/:slug/edit
    if (segments.length === 1 || (segments.length === 2 && segments[1] === 'edit')) {
      navigate(`/clients/cases/${rest}`, { replace: true })
      return
    }

    // /client_cases/:slug/reviews[...] -> fetch the case to resolve its
    // client slug, then land on the equivalent client-level review route.
    if (segments[1] === 'reviews') {
      clientCaseService.getBySlug(caseSlug)
        .then(res => {
          const clientSlug = res.clientCase?.client_slug
          if (!clientSlug) { setNotFound(true); return }
          const reviewRest = segments.slice(2).join('/')
          navigate(`/clients/${clientSlug}/reviews${reviewRest ? '/' + reviewRest : ''}`, { replace: true })
        })
        .catch(() => setNotFound(true))
      return
    }

    setNotFound(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest])

  if (notFound) return <div style={{ padding: 30 }}>Sidan hittades inte.</div>
  return <div style={{ padding: 30, color: 'var(--color-dark-grey)' }}>Omdirigerar…</div>
}
